// extracted by mini-css-extract-plugin
export default {"wrap-form-search":"CommonAction_wrap-form-search__js-sX"};